var _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagkenyaDestination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 35C27.3888 35 35 27.3888 35 18C35 8.61116 27.3888 1 18 1C8.61116 1 1 8.61116 1 18C1 27.3888 8.61116 35 18 35Z",
    fill: "#E2E2FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16220_212506",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 34,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 35C27.3888 35 35 27.3888 35 18C35 8.61116 27.3888 1 18 1C8.61116 1 1 8.61116 1 18C1 27.3888 8.61116 35 18 35Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16220_212506)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.32812,
    y: 1,
    width: 51,
    height: 34,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.32812 1H43.6719V35H-7.32812V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.32812 1H43.6719V11.2H-7.32812V1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.32812 24.8H43.6719V35H-7.32812L-7.32812 24.8Z",
    fill: "#006600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0969 28.0938L12.4649 28.3063L22.3915 11.1131C22.972 10.9575 23.2908 10.4054 23.6095 9.85332C23.822 9.48526 24.672 8.01302 25.0404 6.10001C23.5678 7.37552 22.7178 8.84776 22.5053 9.21582C22.1866 9.76791 21.8678 10.32 22.0234 10.9006L12.0969 28.0938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5175 9.8002C23.7168 9.45502 24.4785 8.13526 24.8702 6.39479C23.5587 7.60426 22.7966 8.92377 22.5973 9.26895C22.4369 9.54683 22.2828 9.81438 22.1865 10.0833C22.091 10.3501 22.0556 10.6103 22.126 10.8731L22.1374 10.9156L12.242 28.0549L12.426 28.1612L22.3214 11.0218L22.3639 11.0104C22.6267 10.94 22.8343 10.7793 23.0176 10.5631C23.2024 10.3453 23.3571 10.0781 23.5175 9.8002ZM23.7015 9.90645C23.5432 10.1806 23.3791 10.4655 23.1797 10.7006C22.988 10.9266 22.7588 11.1127 22.4621 11.2032L12.5038 28.4514L11.9517 28.1327L21.91 10.8845C21.8401 10.5823 21.8866 10.2907 21.9865 10.0117C22.0904 9.72141 22.255 9.43688 22.4133 9.1627C22.6272 8.79229 23.4844 7.30728 24.9708 6.01972L25.2027 5.81884L25.1447 6.12011C24.7728 8.05118 23.9154 9.53604 23.7015 9.90645Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0969 28.0938L12.4649 28.3063L22.3915 11.1131C22.972 10.9575 23.2908 10.4054 23.6095 9.85332C23.822 9.48526 24.672 8.01302 25.0404 6.10001C23.5678 7.37552 22.7178 8.84776 22.5053 9.21582C22.1866 9.76791 21.8678 10.32 22.0234 10.9006L12.0969 28.0938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2469 28.0938L23.8788 28.3063L13.9523 11.1131C13.3717 10.9575 13.053 10.4054 12.7342 9.85332C12.5217 9.48526 11.6717 8.01302 11.3034 6.10001C12.7759 7.37552 13.6259 8.84776 13.8384 9.21582C14.1572 9.76791 14.4759 10.32 14.3204 10.9006L24.2469 28.0938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8263 9.8002C12.627 9.45502 11.8653 8.13526 11.4736 6.39479C12.785 7.60426 13.5471 8.92377 13.7464 9.26895C13.9068 9.54683 14.0609 9.81438 14.1572 10.0833C14.2527 10.3501 14.2881 10.6103 14.2177 10.8731L14.2063 10.9156L24.1017 28.0549L23.9177 28.1612L14.0223 11.0218L13.9798 11.0104C13.717 10.94 13.5094 10.7793 13.3261 10.5631C13.1413 10.3453 12.9867 10.0781 12.8263 9.8002ZM12.6422 9.90645C12.8005 10.1806 12.9646 10.4655 13.1641 10.7006C13.3557 10.9266 13.585 11.1127 13.8817 11.2032L23.8399 28.4514L24.392 28.1327L14.4338 10.8845C14.5037 10.5823 14.4571 10.2907 14.3573 10.0117C14.2534 9.72141 14.0887 9.43688 13.9304 9.1627C13.7166 8.79229 12.8594 7.30728 11.3729 6.01972L11.141 5.81884L11.1991 6.12011C11.5709 8.05118 12.4284 9.53604 12.6422 9.90645Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2469 28.0938L23.8788 28.3063L13.9523 11.1131C13.3717 10.9575 13.053 10.4054 12.7342 9.85332C12.5217 9.48526 11.6717 8.01302 11.3034 6.10001C12.7759 7.37552 13.6259 8.84776 13.8384 9.21582C14.1572 9.76791 14.4759 10.32 14.3204 10.9006L24.2469 28.0938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.32812 12.9V23.1H14.1344C14.7719 24.8 16.8969 28.2 18.1719 28.2C19.4469 28.2 21.5719 24.8 22.2094 23.1H43.6719V12.9H22.2094C21.5719 11.2 19.4469 7.8 18.1719 7.8C16.8969 7.8 14.7719 11.2 14.1344 12.9H-7.32812Z",
    fill: "#BB0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2109 23.1C22.8484 21.4 23.2734 19.7 23.2734 18C23.2734 16.3 22.8484 14.6 22.2109 12.9C21.5734 14.6 21.1484 16.3 21.1484 18C21.1484 19.7 21.5734 21.4 22.2109 23.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1328 23.1C13.4953 21.4 13.0703 19.7 13.0703 18C13.0703 16.3 13.4953 14.6 14.1328 12.9C14.7703 14.6 15.1953 16.3 15.1953 18C15.1953 19.7 14.7703 21.4 14.1328 23.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1703 19.275C18.6398 19.275 19.0203 18.7041 19.0203 18C19.0203 17.2958 18.6398 16.725 18.1703 16.725C17.7009 16.725 17.3203 17.2958 17.3203 18C17.3203 18.7041 17.7009 19.275 18.1703 19.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3828 19.2431C18.3828 19.2431 19.2328 20.9431 19.2328 23.7056C19.2328 26.4681 18.3828 28.1681 18.3828 28.1681V19.2431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.957 16.7568C17.957 16.7568 17.107 15.0568 17.107 12.2943C17.107 9.53184 17.957 7.83184 17.957 7.83184V16.7568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.957 19.2431C17.957 19.2431 17.107 20.9431 17.107 23.7056C17.107 26.4681 17.957 28.1681 17.957 28.1681V19.2431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3828 16.7568C18.3828 16.7568 19.2328 15.0568 19.2328 12.2943C19.2328 9.53184 18.3828 7.83184 18.3828 7.83184V16.7568Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagkenyaDestination);
export default __webpack_public_path__ + "static/media/flagkenyaDestination.ab43da54f2c3431ecb1dcbbd2c0e54c9.svg";
export { ForwardRef as ReactComponent };